import { AppDispatch, ThunkExtraArguments } from "../store";
import { setRetailers } from "../reducers/retailers";
import { getSyncEnabledRetailersAuth, getCheckoutEnabledRetailersAuth } from "../../api/graphQl/authenticated";
import { getRetailers } from "../../api";
import { EligibilityStatus, RetailerWithSyncStatus } from "../types";

/* --------------------- retailers ---------------------*/

interface SyncEnabledRetailersResponse {
  SyncEnabledRetailers: RetailerWithSyncStatus[];
}
interface UnauthRetailerResponse {
  RetailersForLandingPage: RetailerWithSyncStatus[];
}
export const loadRetailersAuth =
  () =>
  async (
    dispatch: AppDispatch,
    _getState: unknown,
    { apolloClient }: ThunkExtraArguments
  ): Promise<RetailerWithSyncStatus[] | null> => {
    try {
      const { data } = await apolloClient.query<SyncEnabledRetailersResponse>({
        query: getSyncEnabledRetailersAuth,
        variables: { enableExperimentalRetailers: true },
        fetchPolicy: "no-cache",
      });
      if (data?.SyncEnabledRetailers?.length > 0) {
        const allRetailers = data.SyncEnabledRetailers.map((retailer) => ({
          ...retailer,
          parentRetailerId: retailer?.parentRetailerId ?? retailer.retailerId,
        }));
        dispatch(setRetailers(allRetailers));
        return allRetailers;
      }
    } catch (e) {
      console.error("loadRetailersAuth error: ", e);
    }
    return null;
  };

export const loadRetailersUnauth =
  () =>
  async (
    dispatch: AppDispatch,
    _getState: unknown,
    { apolloClient }: ThunkExtraArguments
  ): Promise<RetailerWithSyncStatus[] | null> => {
    try {
      const { data } = await apolloClient.query<UnauthRetailerResponse>({
        query: getRetailers,
        variables: { enableExperimentalRetailers: true },
        fetchPolicy: "cache-first",
      });
      const serverSideEnabledRetailers = data?.RetailersForLandingPage.filter(
        (retailer) => {
          return retailer.syncConfig.serverSide === EligibilityStatus.ENABLED;
        }
      );
      dispatch(setRetailers(serverSideEnabledRetailers));
      return serverSideEnabledRetailers;
    } catch (e) {
      console.error("loadRetailersUnauth error: ", e);
    }
    return null;
  };

interface SyncEnabledRetailersResponse {
  SyncEnabledRetailers: RetailerWithSyncStatus[];
}

export const loadSyncEnabledRetailersAuth =
  () =>
  async (
    dispatch: AppDispatch,
    _getState: unknown,
    { apolloClient }: ThunkExtraArguments
  ): Promise<RetailerWithSyncStatus[] | null> => {
    try {
      const { data } = await apolloClient.query<SyncEnabledRetailersResponse>({
        query: getSyncEnabledRetailersAuth,
        variables: { enableExperimentalRetailers: true },
        fetchPolicy: "no-cache",
      });
      if (data?.SyncEnabledRetailers?.length > 0) {
        const allRetailers = data.SyncEnabledRetailers.map((retailer) => ({
          ...retailer,
          parentRetailerId: retailer?.parentRetailerId ?? retailer.retailerId,
        }));
        dispatch(setRetailers(allRetailers));
        return allRetailers;
      }
    } catch (e) {
      console.error("loadSyncEnabledRetailersAuth error: ", e);
    }
    return null;
  };

interface CheckoutEnabledRetailersResponse {
  CheckoutEnabledRetailers: RetailerWithSyncStatus[];
}

export const loadCheckoutEnabledRetailersAuth =
  () =>
  async (
    dispatch: AppDispatch,
    _getState: unknown,
    { apolloClient }: ThunkExtraArguments
  ): Promise<RetailerWithSyncStatus[] | null> => {
    try {
      const { data } = await apolloClient.query<CheckoutEnabledRetailersResponse>({
        query: getCheckoutEnabledRetailersAuth,
        variables: { enableExperimentalRetailers: true },
        fetchPolicy: "no-cache",
      });
      if (data?.CheckoutEnabledRetailers?.length > 0) {
        const allRetailers = data.CheckoutEnabledRetailers.map((retailer) => ({
          ...retailer,
          parentRetailerId: retailer?.parentRetailerId ?? retailer.retailerId,
        }));
        dispatch(setRetailers(allRetailers));
        return allRetailers;
      }
    } catch (e) {
      console.error("loadCheckoutEnabledRetailersAuth error: ", e);
    }
    return null;
  };
